import { render } from "./SkeletonActor.vue?vue&type=template&id=1915bb9d&scoped=true"
import script from "./SkeletonActor.vue?vue&type=script&lang=js"
export * from "./SkeletonActor.vue?vue&type=script&lang=js"

import "./SkeletonActor.vue?vue&type=style&index=0&id=1915bb9d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1915bb9d"]])

export default __exports__